import React, { useMemo, useState } from "react";
import {
  withStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import useFormState, { getSubmitValues } from "../../../util/useFormState";
import { useRegistry } from "../../plugins/registry";
import DraggablePaper from "../../../components/DraggablePaper";
import { useTranslation } from "react-i18next";

const styles = (theme) => ({
  keepOpen: {
    marginLeft: 8,
  },
  flexFill: {
    flex: 1,
  },
});

function CreateArticleDialog(props) {
  const {
    classes,
    open,
    onClose,
    onSubmit,
    type,
    defaultArticle,
    setFormMethods,
    noteColumnTitles,
    isSkuRequired,
  } = props;

  const { t } = useTranslation();
  const registry = useRegistry();

  const formConfig = useMemo(() => {
    const config = registry.articleTypes[type]?.createArticleFormConfig;
    if (config) {
      return {
        ...config,
        sku: {
          ...config.sku,
          required: isSkuRequired || config.required,
          error: isSkuRequired
            ? (sku) => config.sku.error?.(sku) ?? false
            : config.error,
        },
      };
    }
    return config;
  }, [registry.articleTypes, type, isSkuRequired]);
  const [form, inputProps] = useFormState(formConfig, defaultArticle);
  const [keepOpen, setKeepOpen] = useState(false);
  if (setFormMethods) {
    setFormMethods({ reset: form.reset });
  }

  const ArticleForm = type && registry.articleTypes[type].ArticleForm;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableBackdropClick
      PaperComponent={DraggablePaper}
    >
      <DialogTitle id="draggable-paper-handle">
        {t("{{type}}-Artikel hinzufügen", {
          type: type && registry.articleTypes[type].displayName(1, { t }),
          context: type,
        })}
      </DialogTitle>
      <DialogContent>
        {ArticleForm && (
          <ArticleForm
            inputProps={inputProps}
            form={form}
            noteColumnTitles={noteColumnTitles}
          />
        )}
      </DialogContent>
      <DialogActions>
        <FormControlLabel
          className={classes.keepOpen}
          control={
            <Checkbox
              onChange={(e) => setKeepOpen(e.target.checked)}
              checked={keepOpen}
              color="primary"
            />
          }
          label={t("Weitere Artikel hinzufügen")}
        />
        <div className={classes.flexFill} />
        <Button
          onClick={() => {
            form.reset();
            onClose();
          }}
        >
          {t("Abbrechen")}
        </Button>
        <Button
          color="primary"
          onClick={() =>
            onSubmit(
              { ...getSubmitValues(form.values, formConfig), type },
              { keepOpen }
            )
          }
          disabled={!form.canSubmit}
        >
          {t("Hinzufügen")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(CreateArticleDialog);
